import axios from "axios";
import { Message } from "element-ui";

axios.defaults.withCredentials = true;
if (process.env.NODE_ENV !== "production") {
  console.log('开发环境')
} else {
  axios.defaults.baseURL = "http://dt.rdxfpx119.com";
}

// 创建axios实例
const service = axios.create({
  timeout: 60000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code == 101) {
      Message({
        message: "身份过期，请重新登录",
        type: "error",
        duration: 1.5 * 1000,
      });
      setTimeout(function() {
        window.vm.push({ path: "/" });
      }, 1000);
      return res;
    } else {
      return res;
    }
  },
  (error) => {
    console.log(error);
    Message({
      message: error.message,
      type: "error",
      duration: 1.5 * 1000,
    });
    return error.response;
  }
);

export default service;
